
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/transactions/queue",
      function () {
        return require("private-next-pages/transactions/queue.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/transactions/queue"])
      });
    }
  